import React, { useEffect, useState } from "react";
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    Outlet,
    useLocation
} from "react-router-dom";

import Layout from "./components/Layout";
import PaperCategory from "./pages/PaperCategory";
import Dashboard from "./pages/Dashboard";
import AddCategory from "./pages/AddCategory";
import Login from "./pages/Login";
import API_BASE_URL from "./config/api";
import EditCategory from "./pages/EditCategory";
import Papers from "./pages/Papers";
import AddPaper from "./pages/AddPaper";
import EditPaper from "./pages/EditPaper";
import Users from "./pages/Users";
import EditUser from "./pages/EditUser";
import Subjects from "./pages/Subjects";
import AddSubject from "./pages/AddSubject";
import EditSubject from "./pages/EditSubject";
import Sliders from "./pages/Sliders";
import AddSlider from "./pages/AddSlider";
import EditSlider from "./pages/EditSlider";
import Questions from "./pages/Questions";
import AddQuestion from "./pages/AddQuestion";
import EditQuestion from "./pages/EditQuestion";
import PaperQuestions from "./pages/PaperQuestions";
import AddPaperQuestion from "./pages/AddPaperQuestion";
import EditPaperQuestion from "./pages/EditPaperQuestion";
import SocialLinks from "./pages/SocialLinks";
import AddSocialLinks from "./pages/AddSocialLinks";
import EditSocialLinks from "./pages/EditSocialLinks";
import Blogs from "./pages/Blogs";
import AddBlog from "./pages/AddBlog";
import EditBlog from "./pages/EditBlog";
import Testimonials from "./pages/Testimonials";
import Results from "./pages/Results";
import YoutubeVideos from "./pages/YoutubeVideos";
import FreeStudyMaterial from "./pages/FreeStudyMaterial";
import Jobs from "./pages/Jobs";
import Gallery from "./pages/Gallery";
import "quill/dist/quill.snow.css";

function ProtectedRoute() {

    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);

    const location = useLocation();


    useEffect(() => {

        const checkLogin = async () => {

            try {

                const response = await fetch(
                    
                    `${API_BASE_URL}/admin/me`,
                    {
                        method: "GET",

                        headers: {
                            "Accept": "application/json"
                        },

                       

                        credentials: "include"
                    }
                );


                if (response.ok) {

                    const data = await response.json();

                    console.log(
                        "Admin Authentication:",
                        data
                    );

                    setAuthenticated(true);

                } else {

                    setAuthenticated(false);

                }

            } catch (error) {

                console.error(
                    "Authentication Check Error:",
                    error
                );

                setAuthenticated(false);

            } finally {

                setLoading(false);

            }

        };


        checkLogin();

    }, []);


    if (loading) {

        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{
                    minHeight: "100vh"
                }}
            >

                <div
                    className="spinner-border"
                    role="status"
                >
                    <span className="visually-hidden">
                        Loading...
                    </span>
                </div>

            </div>
        );

    }


    /*
    |--------------------------------------------------------------------------
    | Not Authenticated
    |--------------------------------------------------------------------------
    */

    if (!authenticated) {

        return (
            <Navigate
                to="/"
                replace
                state={{
                    from: location
                }}
            />
        );

    }


    /*
    |--------------------------------------------------------------------------
    | Authenticated
    |--------------------------------------------------------------------------
    */

    return <Outlet />;

}


/*
|--------------------------------------------------------------------------
| App
|--------------------------------------------------------------------------
*/

function App() {

    return (

        <BrowserRouter>

            <Routes>



                <Route
                    path="/"
                    element={<Login />}
                />



                <Route
                    element={<ProtectedRoute />}
                >

                    <Route
                        element={<Layout />}
                    >

                        <Route
                            path="/dashboard"
                            element={<Dashboard />}
                        />


                        <Route
                            path="/paper-category"
                            element={<PaperCategory />}
                        />

                        <Route
                            path="/edit-category/:id"
                            element={<EditCategory />}
                        />


                        <Route
                            path="/add-category"
                            element={<AddCategory />}
                        />
                        <Route
                            path="/papers"
                            element={<Papers />}
                        />
                        <Route
                            path="/add-paper"
                            element={<AddPaper />}
                        />
                        <Route
                            path="/edit-paper/:id"
                            element={<EditPaper />}
                        />
                        <Route
                            path="/users"
                            element={<Users />}
                        />
                        <Route
                            path="/edit-user/:userId"
                            element={<EditUser />}
                        />

                        <Route
                            path="/subjects"
                            element={<Subjects />}
                        />

                        <Route
                            path="/add-subject"
                            element={<AddSubject />}
                        />

                        <Route
                            path="/edit-subject/:id"
                            element={<EditSubject />}
                        />
                        <Route
                            path="/sliders"
                            element={<Sliders />}
                        />

                        <Route
                            path="/add-slider"
                            element={<AddSlider />}
                        />

                        <Route
                            path="/edit-slider/:id"
                            element={<EditSlider />}
                        />

                        <Route
                            path="/questions"
                            element={<Questions />}
                        />

                        <Route
                            path="/questions"
                            element={<Questions />}
                        />

                        <Route
                            path="/add-question"
                            element={<AddQuestion />}
                        />

                        <Route
                            path="/edit-question/:id"
                            element={<EditQuestion />}
                        />
                        <Route
                            path="/paperquestions"
                            element={<PaperQuestions />}
                        />

                        <Route
                            path="/add-paper-question"
                            element={<AddPaperQuestion />}
                        />

                        <Route
                            path="/edit-paper-question/:id"
                            element={<EditPaperQuestion />}
                        />
                        <Route
                            path="/social-links"
                            element={<SocialLinks />}
                        />

                        <Route
                            path="/add-social-links"
                            element={<AddSocialLinks />}
                        />

                        <Route
                            path="/edit-social-links/:id"
                            element={<EditSocialLinks />}
                        />
                          <Route path="/blogs" element={<Blogs />} />

                        <Route
                            path="/blogs/add"
                            element={<AddBlog />}
                        />
                        <Route path="/blogs/edit/:id" element={<EditBlog />} />
                        <Route path="/testimonials" element={<Testimonials />} />
                        <Route path="/admin/results" element={<Results />} />
                        <Route path="/youtube-videos" element={<YoutubeVideos />} />
                        <Route
                                path="/free-study-material"
                                element={<FreeStudyMaterial />}
                            />
                        <Route path="/jobs" element={<Jobs />} />
                        <Route
                            path="/gallery"
                            element={<Gallery />}
                        />


                        

                    </Route>

                </Route>


                <Route
                    path="*"
                    element={
                        <Navigate
                            to="/"
                            replace
                        />
                    }
                />

            </Routes>

        </BrowserRouter>

    );

}

export default App;